import "../../polyfills/global";
import { Client } from "@stomp/stompjs";
import SockJS from "sockjs-client";

const TOPIC = "/topic/usuarios-logados";

function urlHttp() {
  return `${(process.env.REACT_APP_GATEWAY || "").replace(/\/$/, "")}/ws`;
}

function urlNativo() {
  return urlHttp().replace(/^http/, "ws");
}

export function conectarUsuariosLogados(onSincronizar) {
  const token = window.localStorage.getItem("@oisol/token");
  if (!token) {
    return () => {};
  }

  const headers = { Authorization: `Bearer ${token}` };
  let ativo = null;
  let encerrado = false;
  let sockJsAtivo = false;

  const assinar = (stomp) => {
    stomp.subscribe(TOPIC, () => {
      if (onSincronizar) {
        onSincronizar();
      }
    });
  };

  const criarCliente = (usarSockJs) => {
    const stomp = new Client({
      ...(usarSockJs
        ? { webSocketFactory: () => new SockJS(urlHttp()) }
        : { brokerURL: urlNativo() }),
      connectHeaders: headers,
      reconnectDelay: usarSockJs ? 5000 : 0,
      heartbeatIncoming: 10000,
      heartbeatOutgoing: 10000,
      onConnect: () => assinar(stomp),
    });
    return stomp;
  };

  const ativarSockJs = () => {
    if (encerrado || sockJsAtivo) return;
    sockJsAtivo = true;
    if (ativo) {
      ativo.deactivate();
    }
    ativo = criarCliente(true);
    ativo.activate();
  };

  ativo = criarCliente(false);
  ativo.onWebSocketError = ativarSockJs;
  ativo.onStompError = ativarSockJs;
  ativo.activate();

  return () => {
    encerrado = true;
    if (ativo) {
      ativo.deactivate();
    }
  };
}
